



























































































































































































import { Dictionary } from "lodash";
import moment from "moment";
import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import {
  GetTreamentGraphResponse,
  RpasApi, TreatmentGraphModel,
  TreatmentMonitoringApi,
  TreatmentRequestModel,
  UnitsApi,
  VariableChartDataModel,
  VariableModel,
  VariablesApi,
} from "../../../apis";
import DataLog from "./DataLog.vue";
import ProcessTime from "./ProcessTime.vue";
import StatusParam from "./StatusParam.vue";
import Params from "./Param.vue";
import Calibration from "./Calibration.vue";
import {
  ITreatmentMonitoringDetail,
} from ".";
import { deepCopy } from "deep-copy-ts";
import { AxiosResponse } from "axios";
import JSCharting from 'jscharting-vue';
@Component({
  components: {
    DataLog,
    ProcessTime,
    StatusParam,
    Calibration,
    Params,
    JSCharting,
  },
})
export default class TreatmentGraph extends Vue {
  @Prop({ default: true }) searchDisplay: boolean;
  @Prop({ default: true }) booleanGrapDisplay: boolean;
  @Prop({ default: "" }) unitId: string;
  @Prop({ default: "" }) selectedTimeZone: string;
  @Prop({ default: false }) graph: boolean;
  @Prop({ default: "" }) startDate: string;
  @Prop({ default: "" }) endDate: string;
  @Prop({ default: "" }) treatmentId: string;
  @Prop({ default: [] }) treatments: TreatmentRequestModel[];
  @Prop({ default: () => [] }) variablesDisplay?: any[];
  @Prop({ default: () => [] }) variablesHidden?: any[];
  @Prop({ default: false }) isExportPdf: boolean;
  variables: VariableModel[] = [];
  chartLoading = false;
  chartBoolLoading = false;
  maxYaxis = 100.0;
  minYaxis = 0.0;
  maxValue = 0;
  minValue = 0;
  seriesRemoved = [];
  chartStyle = {
    width: '1200px !important',
    height: '404px !important',
    minWidth: '1200px !important',
    minHeight: '404px !important',
    maxWidth: 'none !important',
    maxHeight: 'none !important',
  };
  //   option chart 1
  seriesBool = {};
  series = [];
  // series2 = [];
  chartOptions = {
    type: "line",
    axisToZoom: 'xy',
    series: [],
    legend_visible: false,
    defaultPoint: {
      label_visible: false,
      tooltip: this.formatTooltip,
      marker: {
        visible: false,
      }
    },
    yAxis: {
      scale: {
        range: [0, 100],
      },
      line: {
        width: 1,
        color: 'rgba(50,49,48,0.73)',
        caps: {
          start: { type: 'circle' }
        }
      },
      crosshair: {
        enabled:true,
        snapToData:false,
      },
      defaultTick: {
        label_style_fontSize: "8px",
        label_style_fontWeight: 'normal',
        label_style_opacity:1,
      
      },
      defaultMinorTick: {
        label_style_fontSize: "8px",
        label_style_fontWeight: 'normal',
        label_style_opacity:1,
      
      },
      defaultTick_label_text: this.formatLabel
    },
    xAxis: {
      scale: {
        range: [],
      },
      crosshair: {
        enabled:true,
      },
      defaultMinorTick: {
        label_style_fontWeight: 'normal',
        gridLine_color: ['rgba(50,49,48,0.73)', 0.2],
        gridLine_dashStyle: 'Solid'
      },
      defaultTick: {
        label_style_fontWeight: 'bold',
        gridLine_color: ['rgba(50,49,48,0.73)', 0.2],
        label_text: this.tickLabelText
      },
      formatString: 'hh:mm DD/MM',
      line: {
        width: 0.5,
        color: 'rgba(50,49,48,0.73)',
        caps: {
          start: { type: 'circle' }
        }
      },
      scale_type: 'time'
    },
    events_zoomed: this.selectionHandler,
    events_scrolled: this.selectionHandler,
  };

  formatTooltip(data: any) {
    const date = moment.unix(data.x / 1000).format("HH:mm DD/MM");
    return `<b>${date}</b><hr><b>${data.series.name}: ${data.y}</b>`;
  }

  tickLabelText(v: number) {
    return moment.unix(v / 1000).format("HH:mm DD/MM");
  }

  selectionHandler(obj) {
    const min = parseInt(obj[1].min);
    const max = parseInt(obj[1].max);
    if ((min === 0 && max === 100) || (this.searchForm.yMin === min && this.searchForm.yMax === max)) {
      this.searchForm.yMin = null;
      this.searchForm.yMax = null;
      this.chartOptions.yAxis.scale.range = [this.minValue, this.maxValue];
      this.chartOptions.yAxis.scale.range = [0, 100];
      this.reactiveWithNumberChart(true);
    } else {
      this.reactiveWithNumberChart(false);
    }
    this.beforeZoomNumberChart(parseInt(obj[0].min), parseInt(obj[0].max));
  }

  formatLabel(v: number) {
    return v.toFixed(2);
  }

  selectedNumericParam: string[] = [];
  selectedBoolParam: string[] = [];
  selectedUnit: any = null;

  searchForm = {
    dateStart: "",
    dateEnd: "",
    treatmentId: "",
    yMin: null,
    yMax: null,
  };

  showRecountConfimDialog: boolean = false;

  get RANGE_VALUE_YAXIS() {
    return this.maxYaxis - this.minYaxis;
  }

  get RULES_DATE() {
    if (this.searchForm.treatmentId) {
      return '';
    }
    return 'my-required|my-date';
  }

  get TREATMENTS() {
    return !this.treatments
      ? []
      : this.treatments.map((val) => ({
          value: val.id,
          text: val.number,
        }));
  }

  get NUMERIC_PARAMERTERS() {
    let result=  !this.variables
      ? []
      : this.variables
          .filter((val) => ["BYTE", "UBYTE", "WORD" , "FLOATING"].includes(val.type))
          .map((val) => {
            return {
              value: val.id,
              text: val.variableName,
              color: val.color || this.generateRandomColor(),
            };
          });
          if(this.variablesDisplay && this.variablesDisplay.length){
            result = result.filter(val => this.variablesDisplay.includes(val.value));
          }
          if(this.variablesHidden && this.variablesHidden.length){
            result = result.filter(val => !this.variablesHidden.includes(val.value));
          }
      return result;
  }

  get BOOL_PARAMERTERS() {
    if (!this.booleanGrapDisplay){
      return [];
    }
    return !this.variables
      ? []
      : this.variables
          .filter((val) => ["BOOL"].includes(val.type))
          .map((val) => {
            return {
              value: val.id,
              text: val.variableName,
              color: val.color || this.generateRandomColor(),
            };
          });
  }

  get X_HOUR() {
    return this.$util.getConfig().settings.graph.xHour;
  }

  generateRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  created() {
    this.searchForm.dateEnd = moment().format("YYYY-MM-DD");
    this.searchForm.dateStart = moment().add(-7, "days").format("YYYY-MM-DD");
    this.calculateXAxisNumberChart();
  }

  async fetchUnitData() {
    const resp = await new UnitsApi().getUnitById({ id: this.unitId });
    this.selectedUnit = resp.data.data;
  }

  async fetchVariablesData() {
    const resp = await new VariablesApi().getVariablesByUnitId({
      id: this.unitId,
    });
    this.variables = resp.data.data.filter((val) => val.graph);
    this.getSelectedNumericParam();
    this.getSelectedBoolParam();
  }

  getSelectedNumericParam() {
    let store = "treatmentGraphNumber";
    if (this.variablesDisplay && this.variablesDisplay.length){
      store= "treatmentGraphNumber_O2";
    }
    const paramDict =localStorage.getItem(store);
    let params;
    if (paramDict){
      try {
        const data = JSON.parse(paramDict);
        params = data[this.unitId];
      } catch (error) {
        
      }
    }
    if (this.variablesDisplay || this.variablesHidden) {
    if (!params || this.lodash.isEmpty(params)) {
      this.selectedNumericParam = this.NUMERIC_PARAMERTERS.map(
        (val) => val.value
      );
    } else {
      this.selectedNumericParam = this.lodash.intersection(
        params,
        this.NUMERIC_PARAMERTERS.map((val) => val.value)
      );
    }
      return;
    }
    // const paramDict: ITreatmentMonitoringDetail =
    //   this.$store.getters.treatmentMonitoringDetail;
    // const params = paramDict.number[this.unitId];
    if (this.lodash.isEmpty(params)) {
      this.selectedNumericParam = this.NUMERIC_PARAMERTERS.map(
        (val) => val.value
      );
    } else {
      this.selectedNumericParam = this.lodash.intersection(
        params,
        this.NUMERIC_PARAMERTERS.map((val) => val.value)
      );
    }
  }

  getSelectedBoolParam() {
    const paramDict: ITreatmentMonitoringDetail =
      this.$store.getters.treatmentMonitoringDetail;
    const params = paramDict.bool[this.unitId];
    if (this.lodash.isEmpty(params)) {
      this.selectedBoolParam = this.BOOL_PARAMERTERS.map((val) => val.value);
    } else {
      this.selectedBoolParam = this.lodash.intersection(
        params,
        this.BOOL_PARAMERTERS.map((val) => val.value)
      );
    }
  }

  isEmptyChartBool(v: any) {
    if (v && v.series) {
      return this.lodash.isEmpty(v.series[0].data);
    }
    return true;
  }

  mounted() {
    this.$nextTick(() => {
      this.chartLoading = true;
      this.$emit("loaded");
      this.doSearch();
    });
  }

  calculateXAxisNumberChart() {
    let timestampRangeSet = new Set<number>();
    const dateStart = moment(this.searchForm.dateStart, "YYYY-MM-DD");
    const dateEnd = moment(this.searchForm.dateEnd, "YYYY-MM-DD");
    while (dateEnd.diff(dateStart, "days") >= 0) {
      timestampRangeSet.add(dateStart.unix());
      timestampRangeSet.add(dateStart.add(12, "hours").unix());
      timestampRangeSet.add(dateStart.add(12, "hours").unix());
    }
  }

  get VALID_SEARCH_FORM() {
    if (!this.searchForm.treatmentId && !this.searchForm.dateStart && !this.searchForm.dateEnd) {
      return true;
    }
    return false;
  }

  async doSearch() {
    //this.$util.showLoading();
    console.log("loaded Chart ...");
    await this.fetchUnitData();
    await this.fetchVariablesData();
    if (this.$route.query.treatmentNumber) {
      this.searchForm.treatmentId =
        this.$route.query.treatmentNumber.toString();
      this.$router.replace({ query: null });
    }
      let  offset = 0;
      if (this.selectedTimeZone){
        const now = new Date();
        const locationTime = now.toLocaleString("en-US", {timeZone: this.selectedTimeZone});
        const subdate = new Date(locationTime);
        offset = Math.round((subdate.getTime() - now.getTime())/1000);
      }
    this.$emit("onSearch", deepCopy(this.searchForm));
    this.chartBoolLoading = false;
    let hasProDate = false;
    let dateStartQuery: any;
    let dateEndQuery: any;
    if (this.startDate && this.endDate) {
      hasProDate = true;
    }

    if (this.treatmentId) {
      this.searchForm.treatmentId = this.treatmentId;
    }
    if (
      !this.treatments.find(
        (treatment) => treatment.id == this.searchForm.treatmentId
      )
    ) {
      this.searchForm.treatmentId = "";
    }

    if (!this.searchForm.treatmentId) {
      this.searchForm.dateEnd = this.searchForm.dateEnd || moment().format("YYYY-MM-DD");
      this.searchForm.dateStart = this.searchForm.dateStart || moment().add(-3, "days").format("YYYY-MM-DD");
    }
    dateStartQuery = hasProDate
      ? this.startDate
      : !this.searchForm.dateStart
        ? ""
        : moment(this.searchForm.dateStart)
        .startOf("day")
        .utc()
        .format("YYYY-MM-DD HH:mm");
    dateEndQuery = hasProDate
      ? this.endDate
      : !this.searchForm.dateEnd
        ? ""
        : moment(this.searchForm.dateEnd).endOf("day").utc().format("YYYY-MM-DD HH:mm");


    if (this.VALID_SEARCH_FORM) {
      console.log('VALID_SEARCH_FORM');
      return;
    }
    try {
      this.calculateXAxisNumberChart();
      //this.$util.hideLoading();
      this.chartOptions.series = [];
      this.chartLoading = false;
      this.chartOptions.yAxis.scale.range = [0, 100];
      this.searchForm.yMax = null;
      this.searchForm.yMin = null;
      const seriesCopy = [];
      const colors = [];
      const numericParamPromise: Array<Promise<AxiosResponse<GetTreamentGraphResponse>>> = [];
      for (const selectedItem of this.NUMERIC_PARAMERTERS.map(
        (tmp) => tmp.value
      )) {
        numericParamPromise.push(this.getDataChart(
          selectedItem,
          dateStartQuery,
          dateEndQuery
        ));
      }
      await Promise.all(numericParamPromise).then((responseArray) => {
        const totalSeries = [];
        const maxValue = [];
        const minValue = [];
        responseArray.forEach((response) => {
          const treatmentGraphModel = response.data.data;
          treatmentGraphModel.data = treatmentGraphModel.data.map(d=> {return {...d, x: d.x? (d.x + offset): d.x};});
          const serie = this.calcNumeric(treatmentGraphModel);
          const maxValueOfY = Math.max(...serie.data.filter(o=> o.y !== null).map(o => o.y ), 0);
          const minValueOfY = Math.min(...serie.data.filter(o=> o.y !== null).map(o => o.y ), 100);
          maxValue.push(maxValueOfY);
          minValue.push(minValueOfY);
          totalSeries.push(serie);
        });
        this.maxValue = Math.max(...maxValue);
        this.minValue = Math.min(...minValue);
        this.maxValue = Math.round(this.maxValue) + 2;
        this.minValue = Math.floor(this.minValue) - 2;
        if (this.minValue >= this.maxValue) this.minValue = this.maxValue -1;
        return Promise.resolve(totalSeries);
      }).then((totalSeries) => {
        this.chartOptions.yAxis.scale.range = [this.chartOptions.yAxis.scale.range[0], this.maxValue || 100];
        if ((this.chartOptions.yAxis.scale.range[1]- this.chartOptions.yAxis.scale.range[0])> 100){
          this.chartOptions.yAxis.scale['interval'] = 'auto';
        } else {
          this.chartOptions.yAxis.scale['interval'] = 1;
        }
        for (let i = 0; i < this.NUMERIC_PARAMERTERS.length; i++) {
          const param = this.NUMERIC_PARAMERTERS[i];
          const serie = totalSeries.find(value => value.name === param.value);
          if (param) colors.push(param.color);
          else colors.push(this.generateRandomColor());
          serie.nameBK = param.text;
          serie.variableId = param.value;
          seriesCopy.push(serie);
        }
        for (let i = 0; i < seriesCopy.length; i++) {
          this.chartOptions.series.push(
            {
              points: seriesCopy[i].data.map(p => {
                return {
                  x: p.x*1000,
                  y: p.y,
                };
              }),
              name: seriesCopy[i].nameBK,
              color: colors[i],
              variableId: seriesCopy[i].variableId
            }
          );
        }
      }).then(()=> {
        this.chartLoading = true;
      });

      const booleanParamPromise: Array<Promise<AxiosResponse<GetTreamentGraphResponse>>> = [];
      for (const selectedItem of this.BOOL_PARAMERTERS.map(
        (tmp) => tmp.value
      )) {
        booleanParamPromise.push(this.getDataChart(
          selectedItem,
          dateStartQuery,
          dateEndQuery
        ));
      }

      await Promise.all(booleanParamPromise).then((responseArray) => {
        responseArray.forEach((response) => {
          const series2 = [];
          const color2 = [];
          const treatmentGraphModel = response.data.data;
          treatmentGraphModel.data = treatmentGraphModel.data.map(d=> {return {...d, x: d.x? (d.x + offset): d.x};});
          const serie = this.calcBoolean(treatmentGraphModel);
          const param = this.BOOL_PARAMERTERS.find(
            (val) => val.value === serie.name
          );
          if (param) color2.push(param.color);
          else color2.push(this.generateRandomColor());
          series2.push(serie);
          this.seriesBool[serie.name] = this.getOptionBooleanChart(serie.data.map(p => {
            return {
              x: p.x*1000,
              y: p.y,
            };
          }), param.color, serie.name);
        });
      });
      this.chartOptions.yAxis.scale.range = [this.searchForm.yMin || this.minValue || 0, this.searchForm.yMax || this.maxValue];
      this.onSelectedNumericParamWatch(this.selectedNumericParam);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.chartBoolLoading = true;
      setTimeout(() => {
        this.hiddenLogoChart();
      }, 500);
    }
  }

  getOptionBooleanChart(points, color, name) {
    return {
      type: 'areaStep',
      legend_visible: false,
      yAxis: {
        scale: {
          interval: 1,
          minorInterval: 1,
          range: [0, 8],
        },
        defaultTick: {
          gridLine_visible: false,
          label_text: '',
        },
      },
      xAxis: {
        scale_type: 'time',
        defaultTick: {
          gridLine_visible: false,
          label_text: '',
        },
        line: {
          width: 1,
          color: 'rgba(109,108,106,0.12)',
        },
      },
      defaultPoint: {
        label_visible: false,
        tooltip: this.getLabelBooleanChart,
        marker: {
          visible: false,
        },
      },
      defaultSeries: {
        shape_opacity: 1,
        color: color,
      },
      series: [
        {
          line_width: 0.8,
          points: points, name: name, color: color,
        }
      ],
    };
  }

  getLabelBooleanChart(v) {
    const date = moment.unix(v.x / 1000).format("HH:mm DD/MM");
    const name = this.BOOL_PARAMERTERS.find(param => param.value === v.series.name).text;
    const value = v.y === 1 ? 'ON' : 'OFF';
    return `${date} ${name}: ${value}</b>`;
  }

  async doSearchMinMax() {
    this.chartOptions.yAxis.scale.range = [this.searchForm.yMin || this.minValue || 0, this.searchForm.yMax || this.maxValue];
  }

  hiddenLogoChart() {
    const listLogoEle = document.querySelectorAll("[id=brandingLogo]");
    for (let i = 0; i < listLogoEle.length; i++) {
      listLogoEle[i].setAttribute('display', 'None');
    }
  }

  getDataChart(
    variableId: string,
    dateStartQuery: string,
    dateEndQuery: string
  ):  Promise<AxiosResponse<GetTreamentGraphResponse>> {
    return new TreatmentMonitoringApi().getTreatmentGraph({
      variableId: variableId,
      unitId: this.unitId,
      treatmentId: this.searchForm.treatmentId,
      startDate: dateStartQuery,
      endDate: dateEndQuery,
    });
    // return rs.data.data;
  }

  calcNumeric(value: TreatmentGraphModel) {
    const selectedItem = value.variableId;
    const serie = {
      name: selectedItem,
      nameBK: selectedItem,
      data: [],
    };
    let data_sort = this.lodash.sortBy(value.data, (val) => val.x);
    data_sort = this.removeSameValue(data_sort);
    let data_x_start, data_x_end;
    let data_serie = [...data_sort];
    if (!this.searchForm.dateStart && !this.lodash.isEmpty(data_serie)) {
      data_x_start = moment
        .unix(data_serie[0].x)
        .subtract(this.X_HOUR, "hours")
        .unix();
      data_serie = [{ x: data_x_start, y: null }, ...data_serie];
    }
    if (!this.searchForm.dateEnd && !this.lodash.isEmpty(data_serie)) {
      data_x_end = moment
        .unix(data_serie[data_serie.length - 1].x)
        .add(this.X_HOUR, "hours")
        .unix();
      data_serie = [...data_serie, { x: data_x_end, y: null }];
    }
    serie.data = data_serie;
    return serie;
  }

  removeSameValue(dataSort) {
    const REMOVE_LIMIT = 50;
    const dataSortNew = [];
    if (this.lodash.isEmpty(dataSort)) {
      return dataSortNew;
    }
    dataSortNew.push(dataSort[0]);
    let removed = 0;
    for (let i = 1; i < dataSort.length; i++) {
      const previousEle = dataSort[i-1];
      const currentEle = dataSort[i];
      const nextEle = dataSort[i+1];
      if (
        !nextEle
        || ((currentEle && previousEle && currentEle.y !== previousEle.y) || (currentEle && nextEle && currentEle.y !== nextEle.y))
        || (removed >= REMOVE_LIMIT)) {
        dataSortNew.push(currentEle);
        removed = 0;
      } else {
        removed++;
      }
    }
    return dataSortNew;
  }

  calcBoolean(value: TreatmentGraphModel) {
    const selectedItem = value.variableId;
    const serie = {
      name: selectedItem,
      data: [],
    };
    let data_sort = this.lodash.sortBy(value.data, (val) => val.x);
    data_sort = this.removeSameValue(data_sort);
    let data_x_start, data_x_end;
    let data_serie = [...data_sort];
    if (!this.searchForm.dateStart && !this.lodash.isEmpty(data_serie)) {
      data_x_start = moment
        .unix(data_serie[0].x)
        .subtract(this.X_HOUR, "hours")
        .unix();
      data_serie = [{ x: data_x_start, y: null }, ...data_serie];
    }
    if (!this.searchForm.dateEnd && !this.lodash.isEmpty(data_serie)) {
      data_x_end = moment
        .unix(data_serie[data_serie.length - 1].x)
        .add(this.X_HOUR, "hours")
        .unix();
      data_serie = [...data_serie, { x: data_x_end, y: null }];
    }
    serie.data = data_serie;
    return serie;
  }

  onSelectedNumericParamWatch(val: string[]) {
    let store = "treatmentGraphNumber";
    if (this.variablesDisplay && this.variablesDisplay.length){
      store= "treatmentGraphNumber_O2";
    }
    let backup = localStorage.getItem(store);
    if (!backup){
      const data ={};
      data[this.selectedUnit.id] = val;
      localStorage.setItem(store, JSON.stringify(data));
    } else{
      const data = JSON.parse(backup);
      data[this.selectedUnit.id] = val;
      localStorage.setItem(store, JSON.stringify(data));
    }
    // if (this.lodash.isEmpty(this.chartOptions.series)) return;
    this.$util.showLoading();
    setTimeout(() => {
      const a = this.lodash.reject(this.NUMERIC_PARAMERTERS, (p) =>
        val.includes(p.value)
      );
      for (const item of a) {
        const index = this.chartOptions.series.findIndex((s) => s.variableId === item.value);
        if (index !== -1) {
          this.seriesRemoved.push(...this.chartOptions.series.splice(index, 1));
        }
      }

      for (const item of val) {
        const index = this.seriesRemoved.findIndex((s) => s.variableId === item);
        if (index !== -1)
          this.chartOptions.series.push(...this.seriesRemoved.splice(index, 1));
      }
      let maxOfY = 0;
      let minOfY = 100;
      for (let index = 0; index < this.chartOptions.series.length; index++) {
        const element = this.chartOptions.series[index];
        for (let i = 0; i < element.points.length; i++) {
          const point = element.points[i];
          if (point.y != null && point.y >= maxOfY) maxOfY = point.y;
          if (point.y != null && point.y <= minOfY) minOfY = point.y;
        }
       
      }
       if (minOfY >= maxOfY) minOfY = maxOfY -1;
        this.chartOptions.yAxis.scale.range = [minOfY-2 , maxOfY+2];
      if (((maxOfY+2)- (minOfY-2))> 100){
          this.chartOptions.yAxis.scale['interval'] = 'auto';
        } else {
          this.chartOptions.yAxis.scale['interval'] = 1;
        }
      this.$util.hideLoading();
    }, 100);
  }

  onSelectedBoolParamWatch(val: string[]) {
    this.$store.commit("SET_TREATMENT_MONITORING_DETAIL_BOOL", {
      unitId: this.selectedUnit.id,
      params: val,
    });
    this.$util.showLoading();
    setTimeout(() => {
      const a = this.lodash.reject(this.BOOL_PARAMERTERS, (p) =>
        val.includes(p.value)
      );
      this.hiddenLogoChart();
      this.$util.hideLoading();
    }, 100);
  }

  async onRecount() {
    this.$util.showLoading();
    try {
      await new RpasApi().recountRPA({
        id: this.selectedUnit.id,
      });
      this.showRecountConfimDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  beforeZoomNumberChart(min: number, max: number) {
    for (const item of this.selectedBoolParam) {
      const chart = (this.$refs[`boolchart-${item}`][0] as any);
      const xAxis = chart.instance.axes({prefix:'x'}).items[0];
      xAxis.options({ scale_range: [min, max] });
    }
  }

  reactiveWithNumberChart(backToOrigin: boolean) {
    for (const item of this.selectedBoolParam) {
      const booleanChartBox = document.getElementById(`boolean-chart-box-${item}`);
      booleanChartBox.style.marginLeft = backToOrigin && this.maxValue >= 100 ? '40px' : '35px';
    }
  }
}
